<template>
    <v-card min-width="25vw" align="center" outlined>
        <v-card-title >
            <v-list-item>
                <v-list-item-title><h2>{{ $t('title_NotAllowed') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action v-if="!(brokerProblem || assetProblem)"><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
          <h1 class="d-flex justify-center no-trades mb-10">:(</h1>
          <p v-if="brokerProblem"><font v-html="$t('notBrokerAccount')"/>
            <a class="ml-1" href="https://app.swiset.com/profile">{{ $t('clickHere') }}</a>.</p>
          <br v-if="brokerProblem">
          <p v-if="assetProblem && brokerProblem"><font v-html="$t('alsoNotAsset')"/>
            <a class="ml-1" href="https://app.swiset.com/watchlist">{{ $t('clickHere') }}</a>.</p>
          <p v-else-if="assetProblem"><font v-html="$t('notAsset')"/>
            <a class="ml-1" href="https://app.swiset.com/watchlist">{{ $t('clickHere') }}</a>.</p>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "NotAllowed",
        data() {
            return {
                brokerProblem: false,
                assetProblem: false,
            };
        },
        mounted() {
            this.assetProblem = (this.$store.state.user.assets.length === 0);
            this.brokerProblem = (this.$store.state.user.brokerAccounts.length === 0);
        },
        methods: {
            closeWindow(){
                this.$emit('closeWindow');
            }
        }
    }
</script>



<style scoped>
.no-trades {
  font-size: 70px;
}
</style>
